interface ClarityConfiguration {
	enabled?: string;
	projectId?: string;
	environment?: string;
}

let initializationScheduled = false;

export function shouldInitializeClarity({
	enabled,
	projectId,
	environment,
}: ClarityConfiguration): boolean {
	return (
		environment === "production" &&
		enabled === "true" &&
		Boolean(projectId?.trim())
	);
}

export function initializeClarity(): void {
	const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID?.trim();
	const enabled = shouldInitializeClarity({
		enabled: process.env.REACT_APP_CLARITY_ENABLED,
		projectId,
		environment: process.env.NODE_ENV,
	});

	if (!enabled || !projectId || initializationScheduled) {
		return;
	}

	initializationScheduled = true;

	const loadClarity = async () => {
		try {
			const { default: Clarity } = await import("@microsoft/clarity");
			Clarity.init(projectId);
		} catch {
			// Analytics must never affect the application experience.
			initializationScheduled = false;
		}
	};

	if (typeof window.requestIdleCallback === "function") {
		window.requestIdleCallback(
			() => {
				void loadClarity();
			},
			{ timeout: 3000 }
		);
		return;
	}

	window.setTimeout(() => {
		void loadClarity();
	}, 0);
}
